angular.module('unica_archive_event.archive_event_controllers')

.controller('ArchiveEventYearsController', function(
	$rootScope, $scope, $state,
	$confirm,
	ArchiveEventListService
) {
	$scope.years = [];

	$scope.loadYears = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		ArchiveEventListService.years()
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.years = data;
				}
			});
	};

	$scope.loadYears();

})

;